module.exports = __webpack_public_path__ + "img/logo-header-white.46152927.png";